//评估项目
export default {

    install(Vue,options){

        Vue.prototype.global = {
            evaluateType:[
                            {
                              id: 'evaluate_condition',
                              name: '成色信息'
                            },
                          {
                            id: 'evaluate_function',
                            name: '功能信息'
                            }
                          ],
          multipleChoiceType: [
                            {
                              id: 1,
                              name: '单选'
                            },
                          {
                            id: 2,
                            name: '多选'
                            }
                          ],
          isGoodOptions: [
                            {
                              id: 0,
                              name: '否'
                            },
                          {
                            id: 1,
                            name: '是'
                            }
                          ],
          itemOptions: [{
                            id: 'sku_memory',
                            name: '内存'
                          },
                          {
                            id: 'sku_purchase_channel',
                            name: '购买渠道'
                          },
                          {
                            id: 'sku_body_color',
                            name: '机身颜色'
                          },
                          {
                            id: 'sku_warranty_duration',
                            name: '保修时长'
                          },
                          {
                            id: 'sku_small_model',
                            name: '小型号'
                          },
                          {
                            id: 'sku_network',
                            name: '网络制式'
                          },
                          {
                            id: 'sku_cpu',
                            name: '处理器'
                          },
                          {
                            id: 'sku_graphics_card',
                            name: '显卡'
                          },
                          {
                            id: 'sku_solid_drive',
                            name: '固态硬盘'
                          },
                          {
                            id: 'sku_mechanical_drive',
                            name: '机械硬盘'
                          },
                          {
                            id: 'sku_charging_interface',
                            name: '充电接口'
                          },
                          {
                            id: 'sku_charging_method',
                            name: '充电方式'
                          },
                          {
                            id: 'sku_case_size',
                            name: '表壳尺寸'
                          },
                          {
                            id: 'sku_case_material',
                            name: '表壳材质'
                          },
                          {
                            id: 'sku_watch_strap',
                            name: '表带'
                          },
                          {
                            id: 'sku_strap_color',
                            name: '表带颜色'
                          },
                          {
                            id: 'sku_left_right_ear',
                            name: '左右耳'
                          },
                          {
                            id: 'sku_external_keyboard',
                            name: '外置键盘'
                          },
                          {
                            id: 'sku_accessories_situation',
                            name: '配件情况'
                          }
                        ],                           
        };
        
    }

 }
